import React from 'react';
import styled from 'styled-components';
import {DatePicker} from 'antd';
import moment from 'moment';

const FORMAT = 'YYYY-MM-DD';

export default function AdminDateWidget(props) {
  const {value, onChange} = props;

  const disabled = props.disabled || props.readOnly || props.readonly;

  return (
    <Wrapper>
      <DatePicker
        disabled={disabled}
        className="rev-input"
        value={value ? moment(value) : null}
        format={FORMAT}
        onChange={(date) => {
          if (date) {
            onChange(date.format(FORMAT));
          } else {
            onChange(null);
          }
        }}
      />
    </Wrapper>
  );
}

const Wrapper = styled.div`
  & > .ant-picker {
    width: 100%;
    border: 1px solid #d9d9d9;
    min-height: 38px;

    &:hover {
      border: solid 1px var(--primaryColor);
    }

    &.ant-picker-focused {
      border: solid 1px var(--primaryColor);
      box-shadow: none;
    }
  }
`;
